import React from 'react';

function Logo(props) {
  return (
    <img alt="Logo" src="/static/repfabric-logo.png" {...props} height="50px" />
  );
}

export default Logo;
